import { Control, FieldValues, Path, useController } from "react-hook-form";

import { Checkbox, CheckboxProps } from "#shared/view/designSystem/Checkbox";

interface Props<T extends FieldValues> extends CheckboxProps {
  label?: string;
  required?: boolean;
  control: Control<T>;
  name: Path<T>;
}

export const CheckboxController = <T extends FieldValues>({
  name,
  label,
  control,
  ...props
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });
  return (
    <Checkbox
      {...field}
      checked={field.value}
      label={label}
      // oxlint-disable-next-line typescript/no-base-to-string
      error={error?.message?.toString() || !!error?.type}
      {...props}
    />
  );
};
